import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ButtonLoader from "@Shared/components/general/button-loader.vue";
import { mapActions, mapGetters } from "vuex";
import { LOAD_APPLICATION_DATA, SWAP_APPLICANT } from "../../../../store/application-actions";
import SwapApplicationConfirmationModal from "./swap-application-confirmation-modal.vue";
import { CURRENT_APPLICATION } from "../../../../store/application-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SwapApplicantsDropdown",
  components: {
    ButtonLoader,
    SwapApplicationConfirmationModal
  },
  props: {
    clientUsername: {
      type: null,
      required: true
    },
    agentUsername: {
      type: null,
      required: true
    },
    applicationId: {
      type: null,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      selectedApplicant: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [CURRENT_APPLICATION])), {}, {
    disableSwap() {
      return this.disabled || this.loading || !this.applicantsDetails.length;
    },
    applicantsDetails() {
      var _context;
      return _mapInstanceProperty(_context = this.CURRENT_APPLICATION["co-applicants"]).call(_context, (applicant, applicantIndex) => ({
        fullName: this.$options.filters.getApplicantName(applicantIndex + 1, applicant["personal-details"]),
        applicantIndex
      }));
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [SWAP_APPLICANT, LOAD_APPLICATION_DATA])), {}, {
    async handleSwap() {
      this.loading = true;
      try {
        const {
          applicantIndex
        } = this.selectedApplicant;
        const reloadData = await this.SWAP_APPLICANT({
          clientUsername: this.clientUsername,
          applicationId: this.applicationId,
          applicantIndex: applicantIndex
        });
        if (reloadData) {
          await this.LOAD_APPLICATION_DATA({
            clientUsername: this.clientUsername,
            applicationId: this.applicationId,
            agentUsername: this.agentUsername
          });
          this.$refs.modal.$hideModal();
        }
        this.loading = true;
      } catch (error) {
        this.loading = false;
      }
    },
    handleSwapConfirm(applicant) {
      this.selectedApplicant = _objectSpread({}, applicant);
      this.$nextTick(() => {
        this.$refs.modal.$showModal();
      });
    },
    handleModalHidden() {
      this.selectedApplicant = null;
    }
  })
});